interface ImageAnalysisOptions {
  model?: string;
  prompt?: string;
}

interface ImageAnalysisResponse {
  description: string;
  error?: string;
}

/**
 * Analyzes an image using the Ollama API
 * @param imageB64 Base64 encoded image data
 * @param options Configuration options for analysis
 * @returns Promise with the analysis result
 */
export async function analyzeImage(
  imageB64: string, 
  options: ImageAnalysisOptions = {}
): Promise<ImageAnalysisResponse> {
  const { 
    model = 'llama3.2-vision',
    prompt = 'What is in this image? Provide a detailed description.'
  } = options;

  try {
    const response = await fetch('http://localhost:11434/api/generate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        model,
        prompt,
        images: [imageB64],
        stream: false
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const rawText = await response.text();
    const data = JSON.parse(rawText);
    
    return {
      description: data.message?.content || data.response || 'No description generated'
    };
  } catch (err) {
    console.error('Error analyzing image:', err);
    return {
      description: '',
      error: err instanceof Error ? err.message : 'Failed to analyze image'
    };
  }
}

/**
 * Helper function to convert a File/Blob to base64
 * @param file File or Blob to convert
 * @returns Promise with base64 string
 */
export async function fileToBase64(file: File | Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        // Remove data URL prefix (e.g., "data:image/jpeg;base64,")
        const base64 = reader.result.split(',')[1];
        resolve(base64);
      } else {
        reject(new Error('Failed to convert file to base64'));
      }
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
